exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Top-module__top___Wfava{display:grid;gap:20px}.Top-module__top___Wfava img{width:100%;padding:10px 20px 0}.Top-module__top___Wfava p{text-align:center}.Top-module__top___Wfava p.Top-module__error___17Nk3{color:#f44e4e}.Top-module__top___Wfava .Top-module__inputs-wrapper___1ylKd{display:grid;width:100%;gap:10px}.Top-module__top___Wfava .Top-module__inputs-wrapper___1ylKd input{padding:14px 18px;background-color:#f4f4f4;border-radius:4px;border:none;text-align:center}.Top-module__top___Wfava .Top-module__inputs-wrapper___1ylKd input::-moz-placeholder{color:#181818}.Top-module__top___Wfava .Top-module__inputs-wrapper___1ylKd input::placeholder{color:#181818}", ""]);

// exports
exports.locals = {
	"top": "Top-module__top___Wfava",
	"error": "Top-module__error___17Nk3",
	"inputs-wrapper": "Top-module__inputs-wrapper___1ylKd"
};